import { Injectable } from '@angular/core';
import { DashboardRatingTasksResult } from '@core/interfaces/reports/ratings';
import { LineChartResultItem, LineMapperService } from '../../../../core/components/charts/line/services/line.mapper.service';
import { RatingsService } from './api/ratings-api.service';
import { RatingsDashboardStars, RatingsMapperService } from './ratings.mapper.service';

@Injectable({
  providedIn: 'root'
})
export class RatingsResolverService {
  constructor(
    private api: RatingsService,
    private lineChartMapper: LineMapperService,
    private ratingsMapper: RatingsMapperService
  ) { }

  public async getAccountRatingsAverageByTimeline(where): Promise<LineChartResultItem[]> {
    return await this.api.accountRatingsAverageLineChart(where);
  }

  public async getBestRatings(where): Promise<DashboardRatingTasksResult> {
    return await this.api.getRatedTasks({ where, orderBy: 'ratingStars_desc', ratingIn: [3, 4, 5] });
  }

  public async getWorstRatings(where): Promise<DashboardRatingTasksResult> {
    return await this.api.getRatedTasks({ where, orderBy: 'ratingStars_asc', ratingIn: [0, 1, 2] });
  }

  public async getRatingsByQuantity(where): Promise<RatingsDashboardStars[]> {
    const ratingsByQuantity = await this.api.getRatingsByQuantity(where);
    return this.ratingsMapper.convertRatingsByQuantityData(ratingsByQuantity);
  }
}
